// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenu-cls1___59cb7cced12e24d258b","cls2":"AccountMenu-cls2___7803c9036fbca1dab98 AccountMenu-cls1___59cb7cced12e24d258b"};